import { createContext as Ft, useRef as W, useEffect as w, useState as X, useContext as Et, useMemo as gt } from "react";
import { ad as xt, af as ut, U as I, X as Tt, b as kt, k as at, l as _, ac as Z, P as it, q as F, $ as ht, S as P, D as q, O as Y, C as At, N as ct, h as B, g as ft, x as lt, K as Ct, j as bt, z as dt, i as Dt, a3 as wt, J as Pt, ag as It, ah as tt } from "./7FZLUSKW.7Pws8uOI.js";
var St = Ft(!0), R = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function Kt(t) {
  return Number.parseInt(t.getAttribute("tabindex") || "0", 10) < 0;
}
function k(t) {
  return !(!t.matches(R) || !xt(t) || t.closest("[inert]"));
}
function L(t) {
  if (!k(t) || Kt(t)) return !1;
  if (!("form" in t) || !t.form || t.checked || t.type !== "radio") return !0;
  const e = t.form.elements.namedItem(t.name);
  if (!e || !("length" in e)) return !0;
  const r = I(t);
  return !r || r === t || !("form" in r) || r.form !== t.form || r.name !== t.name;
}
function z(t, e) {
  const r = Array.from(
    t.querySelectorAll(R)
  );
  e && r.unshift(t);
  const n = r.filter(k);
  return n.forEach((o, u) => {
    if (ut(o) && o.contentDocument) {
      const f = o.contentDocument.body;
      n.splice(u, 1, ...z(f));
    }
  }), n;
}
function H(t, e, r) {
  const n = Array.from(
    t.querySelectorAll(R)
  ), o = n.filter(L);
  return e && L(t) && o.unshift(t), o.forEach((u, f) => {
    if (ut(u) && u.contentDocument) {
      const i = u.contentDocument.body, d = H(
        i,
        !1,
        r
      );
      o.splice(f, 1, ...d);
    }
  }), !o.length && r ? n : o;
}
function Zt(t, e, r) {
  const [n] = H(
    t,
    e,
    r
  );
  return n || null;
}
function Mt(t, e, r, n) {
  const o = I(t), u = z(t, e), f = u.indexOf(o);
  return u.slice(f + 1).find(L) || null || null || null;
}
function te(t, e) {
  return Mt(
    document.body,
    !1
  );
}
function Vt(t, e, r, n) {
  const o = I(t), u = z(t, e).reverse(), f = u.indexOf(o);
  return u.slice(f + 1).find(L) || null || null || null;
}
function ee(t, e) {
  return Vt(
    document.body,
    !1
  );
}
function Nt(t) {
  for (; t && !k(t); )
    t = t.closest(R);
  return t || null;
}
function et(t) {
  const e = I(t);
  if (!e) return !1;
  if (e === t) return !0;
  const r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function Ot(t) {
  const e = I(t);
  if (!e) return !1;
  if (Tt(t, e)) return !0;
  const r = e.getAttribute("aria-activedescendant");
  return !r || !("id" in t) ? !1 : r === t.id ? !0 : !!t.querySelector(`#${CSS.escape(r)}`);
}
function _t(t) {
  !Ot(t) && k(t) && t.focus();
}
function qt(t) {
  var e;
  const r = (e = t.getAttribute("tabindex")) != null ? e : "";
  t.setAttribute("data-tabindex", r), t.setAttribute("tabindex", "-1");
}
function re(t, e) {
  const r = H(t, e);
  for (const n of r)
    qt(n);
}
function ne(t) {
  const e = t.querySelectorAll("[data-tabindex]"), r = (n) => {
    const o = n.getAttribute("data-tabindex");
    n.removeAttribute("data-tabindex"), o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  };
  t.hasAttribute("data-tabindex") && r(t);
  for (const n of e)
    r(n);
}
function se(t, e) {
  "scrollIntoView" in t ? (t.focus({ preventScroll: !0 }), t.scrollIntoView(kt({ block: "nearest", inline: "nearest" }, e))) : t.focus();
}
var Bt = "div", rt = Dt(), Lt = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
], pt = Symbol("safariFocusAncestor");
function oe(t) {
  return t ? !!t[pt] : !1;
}
function nt(t, e) {
  t && (t[pt] = e);
}
function Rt(t) {
  const { tagName: e, readOnly: r, type: n } = t;
  return e === "TEXTAREA" && !r || e === "SELECT" && !r ? !0 : e === "INPUT" && !r ? Lt.includes(n) : !!(t.isContentEditable || t.getAttribute("role") === "combobox" && t.dataset.name);
}
function Ut(t) {
  return "labels" in t ? t.labels : null;
}
function st(t) {
  return t.tagName.toLowerCase() === "input" && t.type ? t.type === "radio" || t.type === "checkbox" : !1;
}
function jt(t) {
  return t ? t === "button" || t === "summary" || t === "input" || t === "select" || t === "textarea" || t === "a" : !0;
}
function Gt(t) {
  return t ? t === "button" || t === "input" || t === "select" || t === "textarea" : !0;
}
function $t(t, e, r, n, o) {
  return t ? e ? r && !n ? -1 : void 0 : r ? o : o || 0 : o;
}
function $(t, e) {
  return F((r) => {
    t == null || t(r), !r.defaultPrevented && e && (r.stopPropagation(), r.preventDefault());
  });
}
var J = !0;
function Wt(t) {
  const e = t.target;
  e && "hasAttribute" in e && (e.hasAttribute("data-focus-visible") || (J = !1));
}
function Xt(t) {
  t.metaKey || t.ctrlKey || t.altKey || (J = !0);
}
var yt = at(
  function(e) {
    var r = e, {
      focusable: n = !0,
      accessibleWhenDisabled: o,
      autoFocus: u,
      onFocusVisible: f
    } = r, i = _(r, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const d = W(null);
    w(() => {
      n && (Z("mousedown", Wt, !0), Z("keydown", Xt, !0));
    }, [n]), rt && w(() => {
      if (!n) return;
      const s = d.current;
      if (!s || !st(s)) return;
      const c = Ut(s);
      if (!c) return;
      const l = () => queueMicrotask(() => s.focus());
      for (const T of c)
        T.addEventListener("mouseup", l);
      return () => {
        for (const T of c)
          T.removeEventListener("mouseup", l);
      };
    }, [n]);
    const p = n && it(i), y = !!p && !o, [m, b] = X(!1);
    w(() => {
      n && y && m && b(!1);
    }, [n, y, m]), w(() => {
      if (!n || !m) return;
      const s = d.current;
      if (!s || typeof IntersectionObserver > "u") return;
      const c = new IntersectionObserver(() => {
        k(s) || b(!1);
      });
      return c.observe(s), () => c.disconnect();
    }, [n, m]);
    const h = $(
      i.onKeyPressCapture,
      p
    ), S = $(
      i.onMouseDownCapture,
      p
    ), K = $(i.onClickCapture, p), M = i.onMouseDown, V = F((s) => {
      if (M == null || M(s), s.defaultPrevented || !n) return;
      const c = s.currentTarget;
      if (!rt || ht(s) || !P(c) && !st(c)) return;
      let l = !1;
      const T = () => {
        l = !0;
      }, vt = { capture: !0, once: !0 };
      c.addEventListener("focusin", T, vt);
      const Q = Nt(c.parentElement);
      nt(Q, !0), q(c, "mouseup", () => {
        c.removeEventListener("focusin", T, !0), nt(Q, !1), !l && _t(c);
      });
    }), N = (s, c) => {
      if (c && (s.currentTarget = c), !n) return;
      const l = s.currentTarget;
      l && et(l) && (f == null || f(s), !s.defaultPrevented && (l.dataset.focusVisible = "true", b(!0)));
    }, A = i.onKeyDownCapture, U = F((s) => {
      if (A == null || A(s), s.defaultPrevented || !n || m || s.metaKey || s.altKey || s.ctrlKey || !Y(s)) return;
      const c = s.currentTarget;
      q(c, "focusout", () => N(s, c));
    }), a = i.onFocusCapture, v = F((s) => {
      if (a == null || a(s), s.defaultPrevented || !n) return;
      if (!Y(s)) {
        b(!1);
        return;
      }
      const c = s.currentTarget, l = () => N(s, c);
      J || Rt(s.target) ? q(s.target, "focusout", l) : b(!1);
    }), E = i.onBlur, g = F((s) => {
      E == null || E(s), n && At(s) && b(!1);
    }), C = Et(St), j = F((s) => {
      n && u && s && C && queueMicrotask(() => {
        et(s) || k(s) && s.focus();
      });
    }), D = ct(d), G = n && jt(D), O = n && Gt(D), x = i.style, mt = gt(() => y ? B({ pointerEvents: "none" }, x) : x, [y, x]);
    return i = ft(B({
      "data-focus-visible": n && m || void 0,
      "data-autofocus": u || void 0,
      "aria-disabled": p || void 0
    }, i), {
      ref: lt(d, j, i.ref),
      style: mt,
      tabIndex: $t(
        n,
        y,
        G,
        O,
        i.tabIndex
      ),
      disabled: O && y ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: p ? void 0 : i.contentEditable,
      onKeyPressCapture: h,
      onClickCapture: K,
      onMouseDownCapture: S,
      onMouseDown: V,
      onKeyDownCapture: U,
      onFocusCapture: v,
      onBlur: g
    }), Ct(i);
  }
);
bt(function(e) {
  const r = yt(e);
  return dt(Bt, r);
});
var Yt = "button";
function ot(t) {
  if (!t.isTrusted) return !1;
  const e = t.currentTarget;
  return t.key === "Enter" ? P(e) || e.tagName === "SUMMARY" || e.tagName === "A" : t.key === " " ? P(e) || e.tagName === "SUMMARY" || e.tagName === "INPUT" || e.tagName === "SELECT" : !1;
}
var zt = Symbol("command"), Ht = at(
  function(e) {
    var r = e, { clickOnEnter: n = !0, clickOnSpace: o = !0 } = r, u = _(r, ["clickOnEnter", "clickOnSpace"]);
    const f = W(null), i = ct(f), d = u.type, [p, y] = X(
      () => !!i && P({ tagName: i, type: d })
    );
    w(() => {
      f.current && y(P(f.current));
    }, []);
    const [m, b] = X(!1), h = W(!1), S = it(u), [K, M] = wt(u, zt, !0), V = u.onKeyDown, N = F((a) => {
      V == null || V(a);
      const v = a.currentTarget;
      if (a.defaultPrevented || K || S || !Y(a) || Pt(v) || v.isContentEditable) return;
      const E = n && a.key === "Enter", g = o && a.key === " ", C = a.key === "Enter" && !n, j = a.key === " " && !o;
      if (C || j) {
        a.preventDefault();
        return;
      }
      if (E || g) {
        const D = ot(a);
        if (E) {
          if (!D) {
            a.preventDefault();
            const G = a, O = _(G, ["view"]), x = () => tt(v, O);
            It() ? q(v, "keyup", x) : queueMicrotask(x);
          }
        } else g && (h.current = !0, D || (a.preventDefault(), b(!0)));
      }
    }), A = u.onKeyUp, U = F((a) => {
      if (A == null || A(a), a.defaultPrevented || K || S || a.metaKey) return;
      const v = o && a.key === " ";
      if (h.current && v && (h.current = !1, !ot(a))) {
        a.preventDefault(), b(!1);
        const E = a.currentTarget, g = a, C = _(g, ["view"]);
        queueMicrotask(() => tt(E, C));
      }
    });
    return u = ft(B(B({
      "data-active": m || void 0,
      type: p ? "button" : void 0
    }, M), u), {
      ref: lt(f, u.ref),
      onKeyDown: N,
      onKeyUp: U
    }), u = yt(u), u;
  }
);
bt(function(e) {
  const r = Ht(e);
  return dt(Yt, r);
});
export {
  St as F,
  yt as a,
  Ot as b,
  te as c,
  ee as d,
  re as e,
  se as f,
  H as g,
  et as h,
  oe as i,
  Zt as j,
  k,
  _t as l,
  ne as r,
  Ht as u
};
//# sourceMappingURL=ZHUQ44XA.CPgwIBVH.js.map
